// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zEsjCVQ_I_kLNDlj2bfF{width:100%}.r9EQR5I6uaE3RgSIWQGK{justify-content:flex-start;display:flex}.HZB3zZZHXLQKGL8gFZJt{color:var(--content-primary-tertiary);gap:8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown": `zEsjCVQ_I_kLNDlj2bfF`,
	"trigger": `r9EQR5I6uaE3RgSIWQGK`,
	"loading": `HZB3zZZHXLQKGL8gFZJt`
};
export default ___CSS_LOADER_EXPORT___;
